import { SidebarGroup, SidebarMenu } from "ui/components/sidebar";

import { REPORTS } from "icons";
import { NavItem } from "@/components/nav/item";
import { InboxNavigations } from "./inbox";
import { TimesheetNavigations } from "./timesheet";
import { WorkNavigations } from "./work";
import { CrmNavigations } from "./crm";
import { AppsNavigations } from "@/layout/components/nav/app";
import { BookmarksNavigations } from "./bookmarks";
import { HomeNavigations } from "./home";
import { OrgNavigations } from "./org";
import { SupportNavigations } from "./support";
import { MasterDataNavigations } from "./master-data";
import { PerformanceNavigations } from "./performance";
import TaskNavigations from "./task";
import { IntegrationsNavigations } from "./integrations";

export function NavMain() {
  return (
    <SidebarGroup>
      <SidebarMenu>
        {/* <NavItem
          title={
            <div className="text-2xl flex items-center gap-2">
              <span className="text-primary font-honk"> Rewind 2025</span>{" "}
              <Icon icon={MOVE_RIGHT} />
            </div>
          }
          url="https://rewind.everest.7span.work"
          target="_blank"
          rel="noopener noreferrer"
        /> */}
        <HomeNavigations />
        <InboxNavigations />
        <TaskNavigations />
        <BookmarksNavigations />
        <IntegrationsNavigations />
        <WorkNavigations />
        <TimesheetNavigations />
        <NavItem title="Reports" icon={REPORTS} url="/reports" />
        <PerformanceNavigations />
        <CrmNavigations />
        <OrgNavigations />
        <MasterDataNavigations />
        <AppsNavigations />
        <SupportNavigations />
      </SidebarMenu>
    </SidebarGroup>
  );
}
